import { useEffect } from 'react';
import { X } from 'lucide-react';

const Modal = ({ children, onClose, title, size = 'md' }) => {
  const sizeClass =
  size === 'lg'
    ? 'max-w-3xl'
    : size === 'xl'
    ? 'max-w-5xl'
    : size === '2xl'
    ? 'max-w-6xl'
    : 'max-w-md';

  useEffect(() => {
    // Prevent body scroll when modal is open
    document.body.style.overflow = 'hidden';
    
    // Handle escape key
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    
    document.addEventListener('keydown', handleEscape);
    
    return () => {
      document.body.style.overflow = 'unset';
      document.removeEventListener('keydown', handleEscape);
    };
  }, [onClose]);

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4"
      onClick={(e) => {
        // Close modal when clicking on backdrop
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <div 
        className={`bg-white rounded-xl shadow-2xl ${sizeClass} w-full max-h-[70vh] overflow-y-auto relative`}
        onClick={(e) => e.stopPropagation()}
      >
        {title && (
          <div className="flex items-center justify-between p-6 border-b">
            <h2 className="text-xl font-semibold">{title}</h2>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition"
              aria-label="Close"
            >
              <X size={24} />
            </button>
          </div>
        )}
        
        {!title && (
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition z-10"
            aria-label="Close"
          >
            <X size={24} />
          </button>
        )}
        
        <div className={title ? 'p-6' : 'p-6 pt-12'}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
